<script lang="ts">
  import { skyHeightCoefficient } from './pitcyFishConstants';

  export let containerHeight: number;
  $: skyHeight = containerHeight * skyHeightCoefficient;
</script>

<div id="sky" style="height: {skyHeight}px;">
  <!--start Waves -->
  <svg
    class="waves"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 25 180 25"
    preserveAspectRatio="none"
    shape-rendering="auto"
  >
    <defs>
      <path
        id="gentle-wave"
        d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
      />
    </defs>
    <g class="parallax">
      <use xlink:href="#gentle-wave" x="48" y="0" fill="rgba(0,172,193,0.7" />
      <use xlink:href="#gentle-wave" x="48" y="3" fill="rgba(0,172,193,0.5)" />
      <use xlink:href="#gentle-wave" x="48" y="5" fill="rgba(0,172,193,0.4)" />
      <use xlink:href="#gentle-wave" x="48" y="7" fill="rgba(0,172,193,0.4)" />
    </g>
  </svg>
  <!--end Waves -->
</div>

<style>
  /** sky container. Contains the Waves animation. */
  #sky {
    position: absolute;
    z-index: 0;
    top: 0px;
    width: 100%;
    background-color: cyan;
  }
  /** Waves Effect (contained in sky div. Includes 'parallax' and keyframes code.)*/
  .waves {
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: 100%;
    margin-bottom: -7px; /*Fix for safari gap --- TODO: IS THIS NEEDED?? */
  }
  .parallax > use {
    animation: move-forever 23s cubic-bezier(0.55, 0.5, 0.45, 0.5) infinite;
  }
  .parallax > use:nth-child(1) {
    animation-delay: -2s;
    animation-duration: 10s;
  }
  .parallax > use:nth-child(2) {
    animation-delay: -3s;
    animation-duration: 16s;
  }
  .parallax > use:nth-child(3) {
    animation-delay: -4s;
    animation-duration: 13s;
  }
  .parallax > use:nth-child(4) {
    animation-delay: -5s;
    animation-duration: 18s;
  }
  @keyframes move-forever {
    0% {
      transform: translate3d(-90px, 0, 0);
    }
    100% {
      transform: translate3d(85px, 0, 0);
    }
  }
  /** End of CSS waves effect */
</style>
